import * as React from "react";
import { useState, useEffect } from "react";
import i18n from "i18n";
import ReactSelect2 from "common/components/ReactSelect2";

import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import SegmentIcon from "common/assets/images/segment_black_24dp.svg";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import {
  exportAnalyticalGroupedResourceReport,
  exportSyntheticGroupedResourceReport,
} from "../../../costPlan/assets/excelReports/export";

import {
  Dialog,
  DialogContent,
  Radio,
  FormControlLabel,
  withStyles,
  Button,
} from "@material-ui/core";

import { WBSStore } from "../../WBSStore";
import { CustomPropertyStore } from "modules/customProperties/CustomPropertyStore";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      underline: {
        "&:after": {
          borderBottom: "2px solid #9aaf00",
        },
      },
    },
  },
});
const styles = (theme) => ({
  modalTitle: {
    fontFamily: "Roboto",
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "23px",
    borderRadius: "8px",
    letterSpacing: "0em",

    padding: "24px 24px 4px 24px;",
    backgroundColor: "#fff",
    // borderBottom: "1px solid #b1b1b1",
    "& p": { margin: "0px" },
  },
  modalBody: {
    padding: "0px",
    width: "90%",
    height: "auto",
    backgroundColor: "#fff",
    "& p": { margin: "0px" },
  },
  container: {
    display: "flex",
    flexWrap: "wrap" as any,
  },
  filterCheck: {
    color: "rgba(0, 0, 0, 0.6)",
    "&:checked": {
      color: "rgba(171, 194, 0, 1)",
    },
    "&:nth-child(2)": {
      color: "black",
    },
  },
  // btn
  btnBox: {
    marginTop: "26px",
    padding: "0",
    display: "flex",
    justifyContent: "flex-end",
    "& button": { backgroundColor: "transparent", boxShadow: "none" },
  },
  btnCancel: { color: "#aaa" },
  btnExport: { color: theme.palette.primary.light },
});

const ExportByGroupModal = (props) => {
  const { classes } = props;
  const [isAnalytical, setIsAnalytical] = useState(false);
  const [itemSelected, setItemSelected] = useState({
    label: i18n.project.rightSideMenu.type,
    value: 0,
  });
  const [listProperties, setListProperties] = useState<string[]>([]);
  const customProperties = CustomPropertyStore.getWBSCustomProperties();

  useEffect(() => {
    const result: string[] = [];
    result.push(i18n.project.rightSideMenu.type);
    for (let i = 0; i < customProperties.length; i++) {
      const element = customProperties[i];
      result.push(element.data.label);
    }
    setListProperties(result);
  }, []);

  const handleChangeRadio = (event) => {
    setIsAnalytical(!isAnalytical);
  };

  const handleChange = (event, type) => {
    setItemSelected({ label: listProperties[event.value], value: event.value });
  };

  const process = async () => {
    let istype = false;
    let propertyKey = "";
    if (itemSelected.value == 0) {
      istype = true;
    } else {
      propertyKey = customProperties[itemSelected.value - 1].id;
    }

    if (isAnalytical) {
      exportAnalyticalGroupedResourceReport(istype, propertyKey);
    } else {
      exportSyntheticGroupedResourceReport(istype, propertyKey);
    }
  };

  const cancelClick = () => {
    WBSStore.ExportByGroupModal = false;
  };

  return (
    <>
      <Dialog
        {...props}
        open={WBSStore.ExportByGroupModal}
        onClose={cancelClick}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: "#fff",
            borderRadius: "8px",
            width: "1000px",
            overflowY: "visible",
          },
        }}
      >
        <div className={classes.modalTitle}>{i18n.exportByGroup.title}</div>
        <DialogContent
          style={{
            width: "100%",
            overflowY: "visible",
            paddingBottom: "8px",
          }}
        >
          <form className={classes.container}>
            <div className={classes.modalBody}>
              <FormControlLabel
                style={{ color: "#9AAF00 !important", margin: "0" }}
                control={
                  <>
                    <MenuIcon className={classes.imgFilter} />
                    <Radio
                      style={{ padding: 0, marginLeft: 13 }}
                      className={classes.filterCheck}
                      checked={!isAnalytical}
                      onChange={handleChangeRadio}
                      value="syntetic"
                      name="radio-button"
                      aria-label="exportacaoSintetica"
                      icon={
                        <RadioButtonUncheckedIcon
                          fontSize="small"
                          className={classes.filterCheck}
                        />
                      }
                      checkedIcon={
                        <RadioButtonCheckedIcon
                          fontSize="small"
                          style={{ fill: "#9AAF00" }}
                          className={classes.filterCheck}
                        />
                      }
                    />
                  </>
                }
                label={
                  <span
                    style={{
                      color: "#000",
                      paddingLeft: "26px", //styleName: Geral/Pop-up/Adiantamento e Desconto/Título;
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "19px",
                      letterSpacing: "0em",
                      textAlign: "left",
                    }}
                  >
                    {i18n.exportByGroup.syntheticExport}
                  </span>
                }
              />
              <br></br>
              <FormControlLabel
                style={{
                  color: "#9AAF00 !important",
                  margin: "8px 0px 0px 0px",
                }}
                control={
                  <>
                    <img className={classes.imgFilter} src={SegmentIcon} />
                    <Radio
                      style={{ padding: 0, marginLeft: 13 }}
                      className={classes.filterCheck}
                      checked={isAnalytical}
                      onChange={handleChangeRadio}
                      value="analytical"
                      name="radio-button"
                      aria-label="exportacaoAnalitica"
                      icon={
                        <RadioButtonUncheckedIcon
                          fontSize="small"
                          className={classes.filterCheck}
                        />
                      }
                      checkedIcon={
                        <RadioButtonCheckedIcon
                          fontSize="small"
                          style={{ fill: "#9AAF00" }}
                          className={classes.filterCheck}
                        />
                      }
                    />
                  </>
                }
                label={
                  <span
                    style={{
                      color: "#000",
                      paddingLeft: "26px", //styleName: Geral/Pop-up/Adiantamento e Desconto/Título;
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "19px",
                      letterSpacing: "0em",
                      textAlign: "left",
                    }}
                  >
                    {i18n.exportByGroup.analyticalExport}
                  </span>
                }
              />

              <p
                style={{
                  fontFamily: "Roboto",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "19px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  marginTop: "26px",
                  marginBottom: "8px",
                  color: "#000",
                }}
              >
                {i18n.exportByGroup.chooseProperty}
              </p>

              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={listProperties}
                  handleChange={(event) => {
                    handleChange(event, "descriptionColumn");
                  }}
                  value={itemSelected}
                  placeholder={"Propriedade"}
                  boxLine={2}
                  isMulti={false}
                  isClearable={false}
                  boxType="budgetColumn"
                  exportDialog={true}
                />
              </MuiThemeProvider>
            </div>
          </form>
          <div className={classes.btnBox}>
            <Button
              variant="contained"
              onClick={cancelClick}
              className={classes.btnCancel}
            >
              {i18n.cancel}
            </Button>
            <Button
              variant="contained"
              onClick={process}
              className={classes.btnExport}
            >
              {i18n.export}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(ExportByGroupModal);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/ExportByGroup.tsx